import React, { useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import { Base_URL } from "../../../actions/API_endpoint";

const AddEditBlog = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const isEdit = !!id;
  const existingBlog = location.state?.blog || {};

  const [formData, setFormData] = useState({
    title: existingBlog.title || "",
    content: existingBlog.content || "",
    author: existingBlog.author || "Admin",
    slug: existingBlog.slug || "",
    type: existingBlog.type || "other",
    description: existingBlog.description || "",
    date: existingBlog.date || "",
    month: existingBlog.month || "",
    image: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      image: e.target.files[0],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append("title", formData.title);
    data.append("content", formData.content);
    data.append("author", formData.author);
    data.append("slug", formData.slug);
    data.append("type", formData.type);
    data.append("description", formData.description);
    data.append("date", formData.date);
    data.append("month", formData.month);
    if (formData.image) {
      data.append("image", formData.image);
    }

    try {
      if (isEdit) {
        await axios.put(`${Base_URL}/api/blogs/${id}`, data);
      } else {
        await axios.post(`${Base_URL}/api/blogs`, data);
      }
      navigate("/admin/blogs");
    } catch (error) {
      console.error("Error saving blog:", error);
      alert("Error saving blog: " + (error.response?.data?.error || error.message));
    }
  };

  return (
    <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white/5 backdrop-blur-2xl border border-white/20 text-white">
      <div className="rounded-t mb-0 px-6 py-6 border-b border-white/20">
        <div className="text-center flex justify-between">
          <h6 className="text-white text-xl font-bold">
            {isEdit ? "Edit Blog" : "Create Blog"}
          </h6>
        </div>
      </div>
      <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
        <form onSubmit={handleSubmit} className="mt-6">
          <div className="flex flex-wrap">
            <div className="w-full lg:w-6/12 px-4">
              <div className="relative w-full mb-3">
                <label className="block uppercase text-blueGray-300 text-xs font-bold mb-2">
                  Title
                </label>
                <input
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  className="border-0 px-3 py-3 placeholder-blueGray-400 text-white bg-white/10 rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150 border border-white/20"
                  required
                />
              </div>
            </div>
            <div className="w-full lg:w-6/12 px-4">
              <div className="relative w-full mb-3">
                <label className="block uppercase text-blueGray-300 text-xs font-bold mb-2">
                  Slug (URL-friendly)
                </label>
                <input
                  type="text"
                  name="slug"
                  value={formData.slug}
                  onChange={handleChange}
                  className="border-0 px-3 py-3 placeholder-blueGray-400 text-white bg-white/10 rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150 border border-white/20"
                  required
                />
              </div>
            </div>
            <div className="w-full lg:w-6/12 px-4">
              <div className="relative w-full mb-3">
                <label className="block uppercase text-blueGray-300 text-xs font-bold mb-2">
                  Type
                </label>
                <select
                  name="type"
                  value={formData.type}
                  onChange={handleChange}
                  className="border-0 px-3 py-3 placeholder-blueGray-400 text-white bg-white/10 rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150 border border-white/20"
                >
                  <option value="other" className="text-black">Other</option>
                  <option value="workshop" className="text-black">Workshop</option>
                  <option value="news" className="text-black">News</option>
                  <option value="events" className="text-black">Events</option>
                </select>
              </div>
            </div>
            <div className="w-full lg:w-6/12 px-4">
              <div className="relative w-full mb-3">
                <label className="block uppercase text-blueGray-300 text-xs font-bold mb-2">
                  Date (e.g., 22-25)
                </label>
                <input
                  type="text"
                  name="date"
                  value={formData.date}
                  onChange={handleChange}
                  className="border-0 px-3 py-3 placeholder-blueGray-400 text-white bg-white/10 rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150 border border-white/20"
                />
              </div>
            </div>
            <div className="w-full lg:w-6/12 px-4">
              <div className="relative w-full mb-3">
                <label className="block uppercase text-blueGray-300 text-xs font-bold mb-2">
                  Month (e.g., Mar 2023)
                </label>
                <input
                  type="text"
                  name="month"
                  value={formData.month}
                  onChange={handleChange}
                  className="border-0 px-3 py-3 placeholder-blueGray-400 text-white bg-white/10 rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150 border border-white/20"
                />
              </div>
            </div>
            <div className="w-full lg:w-6/12 px-4">
              <div className="relative w-full mb-3">
                <label className="block uppercase text-blueGray-300 text-xs font-bold mb-2">
                  Author
                </label>
                <input
                  type="text"
                  name="author"
                  value={formData.author}
                  onChange={handleChange}
                  className="border-0 px-3 py-3 placeholder-blueGray-400 text-white bg-white/10 rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150 border border-white/20"
                />
              </div>
            </div>
            <div className="w-full lg:w-6/12 px-4">
              <div className="relative w-full mb-3">
                <label className="block uppercase text-blueGray-300 text-xs font-bold mb-2">
                  Image
                </label>
                <input
                  type="file"
                  onChange={handleFileChange}
                  className="border-0 px-3 py-3 placeholder-blueGray-400 text-white bg-white/10 rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150 border border-white/20"
                />
              </div>
            </div>
            <div className="w-full px-4">
              <div className="relative w-full mb-3">
                <label className="block uppercase text-blueGray-300 text-xs font-bold mb-2">
                  Short Description
                </label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  rows="3"
                  className="border-0 px-3 py-3 placeholder-blueGray-400 text-white bg-white/10 rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150 border border-white/20"
                />
              </div>
            </div>
            <div className="w-full px-4">
              <div className="relative w-full mb-3">
                <label className="block uppercase text-blueGray-300 text-xs font-bold mb-2">
                  Content
                </label>
                <textarea
                  name="content"
                  value={formData.content}
                  onChange={handleChange}
                  rows="6"
                  className="border-0 px-3 py-3 placeholder-blueGray-400 text-white bg-white/10 rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150 border border-white/20"
                  required
                />
              </div>
            </div>
          </div>
          <div className="flex justify-center mt-6">
            <button
              className="bg-lightBlue-600 text-white active:bg-lightBlue-700 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 border border-white/20"
              type="submit"
            >
              {isEdit ? "Update Blog" : "Create Blog"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddEditBlog;
